
module.exports = {"attributes":{"width":"11","height":"22","viewBox":"0 0 11 22","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"content":"<g transform=\"translate(1 1)\">         <use xlink:href=\"#tsa\" fill=\"currentColor\"/>         <use xlink:href=\"#tsb\"/>     </g>     <defs>         <path id=\"tsa\" d=\"M0 4.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0z\"/>         <path id=\"tsb\" d=\"M5 21V8.5H4V21h1zM4.5-.5a5 5 0 0 0-5 5h1a4 4 0 0 1 4-4v-1zm0 1a4 4 0 0 1 4 4h1a5 5 0 0 0-5-5v1zm4 4a4 4 0 0 1-4 4v1a5 5 0 0 0 5-5h-1zm-4 4a4 4 0 0 1-4-4h-1a5 5 0 0 0 5 5v-1z\"/>     </defs>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)



//////////////////
// WEBPACK FOOTER
// ./src/components/LoadMap/truckStop.svg
// module id = 1691
// module chunks = 0